import { render, staticRenderFns } from "./VxBreadcrumb.vue?vue&type=template&id=5d02e88f&functional=true"
import script from "./VxBreadcrumb.vue?vue&type=script&lang=js"
export * from "./VxBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d02e88f')) {
      api.createRecord('5d02e88f', component.options)
    } else {
      api.rerender('5d02e88f', component.options)
    }
    module.hot.accept("./VxBreadcrumb.vue?vue&type=template&id=5d02e88f&functional=true", function () {
      api.rerender('5d02e88f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/VxBreadcrumb.vue"
export default component.exports